module.exports = __webpack_public_path__ + "static/the-art-of-being-unreasonable-9d367b4853f206d4380b59b7c2775ce7.jpg";